import { create } from 'zustand';
import type { RealtimeState } from '../lib/realtime-core.js';

/** App-wide live-updates status (the shell's realtime subscription), shown as a chip in the header. */
export const useRealtimeStatus = create<RealtimeState>(() => ({
  status: 'off',
  attempt: 0,
  retryInMs: null,
  error: null,
}));
